import { render, staticRenderFns } from "./Trans.vue?vue&type=template&id=e3f918a0&scoped=true&"
import script from "./Trans.vue?vue&type=script&lang=js&"
export * from "./Trans.vue?vue&type=script&lang=js&"
import style0 from "./Trans.vue?vue&type=style&index=0&id=e3f918a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f918a0",
  null
  
)

export default component.exports